import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import {
  FormGroup,
  Input,
  Checkbox,
  FormControlLabel,
  InputAdornment,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Dialog,
  DialogTitle,
  DialogContent,
  Paper,
  DialogActions,
  Grid
} from "@material-ui/core";
import { Tooltip, Button, IconButton, TextField, Panel } from '@michelin/acid-components'
import MaterialInputable from "../MaterialInputable";
import MaterialSelectable from "../MaterialSelectable";
import InboundPhone from "../InboundPhone";
import api from "../../api";
import { Search as SearchIcon, Delete as DeleteIcon, Add as AddIcon } from "@material-ui/icons";

const styles = theme => ({
  textField: {
    marginLeft: 0,
    marginRight: 0
  },
  paddingMe: {
    marginLeft: "20px"
  },
  paper: {
  },
  checkbox: {
    marginRight: theme.spacing(4),
  }
});

class NewDialog extends React.Component {
  /**
   * Handles the default constructor
   * @param {props} props - the inbound props
   * @returns {void} - no return value
   * @public
   */
  constructor(props) {
    super(props);

    const states = [
      { name: "Alabama", short: "Ala", id: "AL", country: "USA" },
      { name: "Alaska", short: "Alaska", id: "AK", country: "USA" },
      { name: "Arizona", short: "Ariz.", id: "AZ", country: "USA" },
      { name: "Arkansas", short: "Ark.", id: "AR", country: "USA" },
      { name: "California", short: "Calif.", id: "CA", country: "USA" },
      { name: "Colorado", short: "Colo.", id: "CO", country: "USA" },
      { name: "Connecticut", short: "Conn.", id: "CT", country: "USA" },
      { name: "Delaware", short: "Del.", id: "DE", country: "USA" },
      { name: "Dist.of Columbia", short: "D.C.", id: "DC", country: "USA" },
      { name: "Florida", short: "Fla.", id: "FL", country: "USA" },
      { name: "Georgia", short: "Ga.", id: "GA", country: "USA" },
      { name: "Hawaii", short: "Hawaii", id: "HI", country: "USA" },
      { name: "Idaho", short: "Idaho", id: "ID", country: "USA" },
      { name: "Illinois", short: "Ill.", id: "IL", country: "USA" },
      { name: "Indiana", short: "Ind.", id: "IN", country: "USA" },
      { name: "Iowa", short: "Iowa", id: "IA", country: "USA" },
      { name: "Kansas", short: "Kans.", id: "KS", country: "USA" },
      { name: "Kentucky", short: "Ky.", id: "KY", country: "USA" },
      { name: "Louisiana", short: "La.", id: "LA", country: "USA" },
      { name: "Maryland", short: "MD", id: "MD", country: "USA" },
      { name: "Maine", short: "Maine", id: "ME", country: "USA" },
      { name: "Massachusetts", short: "Mass.", id: "MA", country: "USA" },
      { name: "Michigan", short: "Mich.", id: "MI", country: "USA" },
      { name: "Minnesota", short: "Minn.", id: "MN", country: "USA" },
      { name: "Mississippi", short: "Miss.", id: "MS", country: "USA" },
      { name: "Missouri", short: "Mo.", id: "MO", country: "USA" },
      { name: "Montana", short: "Mont.", id: "MT", country: "USA" },
      { name: "Nebraska", short: "Nebr.", id: "NE", country: "USA" },
      { name: "Nevada", short: "Nev.", id: "NV", country: "USA" },
      { name: "New Hampshire", short: "N.H.", id: "NH", country: "USA" },
      { name: "New Jersey", short: "N.J.", id: "NJ", country: "USA" },
      { name: "New Mexico", short: "N.M.", id: "NM", country: "USA" },
      { name: "New York", short: "N.Y.", id: "NY", country: "USA" },
      { name: "North Carolina", short: "N.C.", id: "NC", country: "USA" },
      { name: "North Dakota", short: "N.D.", id: "ND", country: "USA" },
      { name: "Ohio", short: "Ohio", id: "OH", country: "USA" },
      { name: "Oklahoma", short: "Okla.", id: "OK", country: "USA" },
      { name: "Oregon", short: "Ore.", id: "OR", country: "USA" },
      { name: "Pennsylvania", short: "Pa.", id: "PA", country: "USA" },
      { name: "Rhode Island", short: "R.I.", id: "RI", country: "USA" },
      { name: "South Carolina", short: "S.C.", id: "SC", country: "USA" },
      { name: "South Dakota", short: "S.D.", id: "SD", country: "USA" },
      { name: "Tennessee", short: "Tenn.", id: "TN", country: "USA" },
      { name: "Texas", short: "Tex.", id: "TX", country: "USA" },
      { name: "Utah", short: "Utah", id: "UT", country: "USA" },
      { name: "Vermont", short: "Vt.", id: "VT", country: "USA" },
      { name: "Virginia", short: "Va.", id: "VA", country: "USA" },
      { name: "Washington", short: "Wash.", id: "WA", country: "USA" },
      { name: "West Virginia", short: "W.Va.", id: "WV", country: "USA" },
      { name: "Wisconsin", short: "Wis.", id: "WI", country: "USA" },
      { name: "Wyoming", short: "Wyo.", id: "WY", country: "USA" },

      { name: "Alberta", short: "AB", id: "AB", country: "CAN" },
      { name: "British Columbia", short: "BC", id: "BC", country: "CAN" },
      { name: "Manitoba", short: "MB", id: "MB", country: "CAN" },
      { name: "New Brunswick", short: "NB", id: "NB", country: "CAN" },
      { name: "Newfoundland", short: "NL", id: "NL", country: "CAN" },
      { name: "Northwest Territories", short: "NT", id: "NT", country: "CAN" },
      { name: "Nunavut", short: "NU", id: "NU", country: "CAN" },
      { name: "Ontario", short: "ON", id: "ON", country: "CAN" },
      { name: "Price Edward Island", short: "PE", id: "PE", country: "CAN" },
      { name: "Quebec", short: "QC", id: "QC", country: "CAN" },
      { name: "Saskatchewan", short: "SK", id: "SK", country: "CAN" },
      { name: "Yukon", short: "YT", id: "YT", country: "CAN" }
    ];

    this.state = {
      nameSearch: false,
      potentialCustomers: [],
      newInboundProgram: props.loadedProgram ? props.loadedProgram : {},
      inboundProgramAccountTypes: props.inboundProgramAccountTypes,
      closeMe: props.closeMe,
      fetchNumbers: props.fetchNumbers,
      shipToSearch: false,
      shipTos: [],
      shipToSearchCity: "",
      shipToSearchState: "",
      states: states,
      isEdit: props.isEdit,
      isSaving: false
    };

    this.newOnChangeCustomerName = this.newOnChangeCustomerName.bind(this);
    this.newOnChange = this.newOnChange.bind(this);
    this.removeChange = this.removeChange.bind(this)
    this.newNewOnChange = this.newNewOnChange.bind(this)
    this.startShipToSearch = this.startShipToSearch.bind(this);
    this.loadCustomer = this.loadCustomer.bind(this);
    this.loadShipTo = this.loadShipTo.bind(this);
    this.closeInbound = this.closeInbound.bind(this);
    this.startSave = this.startSave.bind(this);
    this.saveNewInbound = this.saveNewInbound.bind(this);
    this.shipToSearchChange = this.shipToSearchChange.bind(this);
  }

  async find(name, dropdown, optionalProgram) {
    let response = [];
    const fleetId = dropdown.filter(x => x.name === "Fleet")[0].id;
    const dealerId = dropdown.filter(x => x.name === "Dealer")[0].id;

    if ((optionalProgram && optionalProgram.accountTypeId !== dealerId) || (!optionalProgram && this.state.newInboundProgram.accountTypeId !== dealerId)) {
      let fleetResponse = await api.service("fleetLocations").find({
        query: {
          name: { $iLike: "%" + name + "%" },
          isBillTo: true,
          $limit: 200
        }
      });

      const fleets = fleetResponse.data.map(f => {
        return {
          customerName: f.name,
          billTo: f.accountNumber,
          accountTypeId: fleetId,
          accountTypeName: "Fleet"
        };
      });

      response = response.concat(fleets);
    }

    if ((optionalProgram && optionalProgram.accountTypeId !== fleetId) || (!optionalProgram && this.state.newInboundProgram.accountTypeId !== fleetId)) {
      let dealerResponse = await api.service("dealerLocations").find({
        query: {
          name: { $iLike: "%" + name + "%" },
          isBillTo: true,
          $limit: 200
        }
      });
      const dealers = dealerResponse.data.map(d => {
        return {
          customerName: d.name,
          billTo: d.accountNumber,
          accountTypeId: dealerId,
          accountTypeName: "Dealer"
        };
      });
      response = response.concat(dealers);
    }
    return response;
  }

  removeChange(index) {
    let program = this.state.newInboundProgram
    program.vehicleTypes.splice(index, 1)
    this.setState({
      newInboundProgram: program,
    });
  }

  newNewOnChange() {
    let program = this.state.newInboundProgram
    program.vehicleTypes.push({})
    this.setState({
      newInboundProgram: program,
    });
  }

  newOnChange(event) {
    const name = event.target.name;
    const val = event.target.value;
    const type = event.target.type;

    let program = this.state.newInboundProgram;

    if (/required/.test(name)) {
      program.vehicleTypes[parseInt(name.replace('required', ''), 10)].required = val

    } else if (/vehicleTypes/.test(name)) {
      program.vehicleTypes[parseInt(name.replace('vehicleTypes', ''), 10)].vehicleTypesId = val
    } else {
      program[name] = type === "checkbox" ? event.target.checked : val;
    }

    if (name === 'accountTypeId') {
      this.find(this.state.newInboundProgram.customerName, this.state.inboundProgramAccountTypes, program).then(x => {
        if (x.length > 0) {
          this.setState({
            nameSearch: true,
            potentialCustomers: x
          });
        } else {
          this.setState({
            nameSearch: false
          });
        }
      });
    }
    this.setState({
      newInboundProgram: program,
    });
  }

  closeInbound() {
    this.state.closeMe();
    this.setState({
      newInboundProgram: {},
      potentialCustomers: [],
      isSaving: false
    });
  }

  async startShipToSearch() {
    const billTo = this.state.newInboundProgram.billTo;
    if (!billTo) {
      return;
    }
    let shipTos = await this.getShipTos();
    this.setState({ shipToSearch: true, shipTos: shipTos });
  }

  loadShipTo(shipTo) {
    let program = this.state.newInboundProgram;
    program.shipTo = shipTo;
    this.setState({
      newInboundProgram: program,
      shipTos: [],
      shipToSearch: false
    });
  }

  loadCustomer(customerName, billTo, accountTypeId) {
    let program = this.state.newInboundProgram;
    program.customerName = customerName;
    program.billTo = billTo;
    program.accountTypeId = accountTypeId;
    this.setState({
      newInboundProgram: program,
      nameSearch: false,
      potentialCustomers: []
    });
  }

  async startSave() {
    this.setState({
      isSaving: true
    });
  }

  async saveNewInbound() {
    const newInboundProgram = this.state.newInboundProgram;
    let fail = false;
    newInboundProgram.customerNameErrorMessage = "";
    newInboundProgram.tollFreeNumberErrorMessage = "";
    newInboundProgram.billToErrorMessage = "";
    newInboundProgram.accountTypeIdErrorMessage = "";

    if (!newInboundProgram.customerName) {
      fail = true;
      newInboundProgram.customerNameErrorMessage = "Must be populated";
    }
    if (
      !newInboundProgram.tollFreeNumber ||
      !(newInboundProgram.tollFreeNumber.replace(/[+() -]/gi, "").length === 11)
    ) {
      fail = true;
      newInboundProgram.tollFreeNumberErrorMessage =
        "Must be populated and 11 digits";
    }
    if (!newInboundProgram.accountTypeId) {
      fail = true;
      newInboundProgram.accountTypeIdErrorMessage = "Must be populated";
    }
    if (fail) {
      this.setState({
        newInboundProgram: newInboundProgram
      });
      return;
    }
    if (!this.state.isEdit) {
      await api.service("inboundProgramNumbers").create({
        customerName: newInboundProgram.customerName,
        tollFreeNumber: newInboundProgram.tollFreeNumber.replace(
          /[() -]/gi,
          ""
        ),
        accountTypeId: newInboundProgram.accountTypeId,
        billTo: newInboundProgram.billTo,
        shipTo: newInboundProgram.shipTo,
        excludeAutoClose: newInboundProgram.excludeAutoClose,
        assetSuccessInstructions: newInboundProgram.assetSuccessInstructions,
        assetFailureInstructions: newInboundProgram.assetFailureInstructions,
        assetValidationFlag: newInboundProgram.assetValidationFlag,
        validatePrimaryAssetFlag: newInboundProgram.validatePrimaryAssetFlag,
        isEsd: newInboundProgram.isEsd,
        isDisabled: newInboundProgram.isDisabled
      });
    } else {
      await api.service("inboundProgramNumbers").patch(newInboundProgram.id, {
        customerName: newInboundProgram.customerName,
        tollFreeNumber: newInboundProgram.tollFreeNumber.replace(
          /[() -]/gi,
          ""
        ),
        accountTypeId: newInboundProgram.accountTypeId,
        billTo: newInboundProgram.billTo,
        shipTo: newInboundProgram.shipTo,
        excludeAutoClose: newInboundProgram.excludeAutoClose,
        assetSuccessInstructions: newInboundProgram.assetSuccessInstructions,
        assetFailureInstructions: newInboundProgram.assetFailureInstructions,
        assetValidationFlag: newInboundProgram.assetValidationFlag,
        validatePrimaryAssetFlag: newInboundProgram.validatePrimaryAssetFlag,
        isEsd: newInboundProgram.isEsd,
        isDisabled: newInboundProgram.isDisabled
      });
    }

    await api.service("inboundProgramAssetValidations").remove(null, {
      query: {
        inboundProgramId: {
          $eq: newInboundProgram.id
        }
      }
    })

    await api.service("inboundProgramVehicleTypes").remove(null, {
      query: {
        inboundProgramId: {
          $eq: newInboundProgram.id
        }
      }
    })

    if (newInboundProgram.assetTypes) {

      for (var a = 0; a < newInboundProgram.assetTypes.length; a++) {
        let aObject = newInboundProgram.assetTypes[a]
        if (aObject.assetValidationId) {
          await api.service("inboundProgramAssetValidations").create({
            inboundProgramId: newInboundProgram.id,
            assetValidationId: aObject.assetValidationId
          })
        } else {
          await api.service("inboundProgramAssetValidations").create({
            inboundProgramId: newInboundProgram.id,
            assetValidationId: aObject
          })
        }
      }
    }
    if (newInboundProgram.vehicleTypes) {

      for (var v = 0; v < newInboundProgram.vehicleTypes.length; v++) {

        let vObject = newInboundProgram.vehicleTypes[v]
        await api.service("inboundProgramVehicleTypes").create({
          inboundProgramId: newInboundProgram.id,
          vehicleTypesId: vObject.vehicleTypesId,
          required: vObject.required
        })
        // if (vObject.vehicleTypesId) {
        //   await api.service("inboundProgramVehicleTypes").create({
        //     inboundProgramId: newInboundProgram.id,
        //     vehicleTypesId: vObject.vehicleTypesId,
        //   })
        // } else {
        //   await api.service("inboundProgramVehicleTypes").create({
        //     inboundProgramId: newInboundProgram.id,
        //     vehicleTypesId: vObject
        //   })
        // }
      }
    }

    await this.state.fetchNumbers();
    this.setState({
      potentialCustomers: [],
    });
    this.closeInbound();
  }

  async getShipTos(state, city) {
    let billTo = await api.service("fleetLocations").find({
      query: {
        accountNumber: { $eq: this.state.newInboundProgram.billTo }
      }
    });
    if (billTo.data.length < 1) return [];
    let resp = await api.service("fleetLocations").find({
      query: {
        parentId: { $eq: billTo.data[0].id },
        isShipTo: true,
        $include: ["address"],
        $limit: 200
      }
    });
    let shipTos = resp.data.filter(
      f =>
        (city ? f.address.city.toUpperCase().includes(city) : true) &&
        (state ? f.address.state === state : true)
    );

    return shipTos;
  }

  async shipToSearchChange(event) {
    const newValue = event.target.value;
    const eventName = event.target.name;
    let shipTos = null;

    if (eventName === "City") {
      shipTos = await this.getShipTos(this.state.shipToSearchState, newValue);
      if (shipTos) {
        this.setState({ shipToSearchCity: newValue, shipTos: shipTos });
      } else {
        this.setState({ shipToSearchCity: newValue });
      }
    } else {
      shipTos = await this.getShipTos(newValue, this.state.shipToSearchCity);
      if (shipTos) {
        this.setState({ shipToSearchState: newValue, shipTos: shipTos });
      } else {
        this.setState({ shipToSearchState: newValue });
      }
    }
  }

  newOnChangeCustomerName(event) {
    const val = event.target.value;
    let inbound = this.state.newInboundProgram;
    inbound.customerName = val;

    this.setState({
      newInboundProgram: inbound
    });

    if (val.length > 2) {
      let inboundProgramAccountTypes = this.state.inboundProgramAccountTypes;
      this.find(val, inboundProgramAccountTypes).then(x => {
        if (x.length > 0) {
          this.setState({
            nameSearch: true,
            potentialCustomers: x
          });
        } else {
          this.setState({
            nameSearch: false
          });
        }
      });
    }
  }

  render() {
    const {
      classes,
      open,
      isSaving,
      inboundProgramAccountTypes,
      assetValidationTypes,
      vehicleTypes,
      isEdit,
      isEagleSupervisor
    } = this.props;

    return (
      <Dialog
        open={open || false}
        onClose={this.closeInbound}
        fullWidth={true}
        maxWidth="lg"
      >
        {isEdit ? <DialogTitle>Edit Inbound Program</DialogTitle> : <DialogTitle>Add New Inbound Program</DialogTitle>}
        <DialogContent>
          <Grid container spacing={2}>
            <Grid item xs={6} sm={4} md={2}>
              <MaterialSelectable
                required
                fullWidth
                label="Account Type"
                errorMessage={
                  this.state.newInboundProgram.accountTypeIdErrorMessage
                }
                error={!!this.state.newInboundProgram.accountTypeIdErrorMessage}
                value={this.state.newInboundProgram.accountTypeId}
                name={"accountTypeId"}
                options={inboundProgramAccountTypes}
                onChange={this.newOnChange}
                disabled={!isEagleSupervisor}
              />
            </Grid>
            <Grid item xs={6} sm={4} md={4}>
              <TextField
                required
                fullWidth
                label="Customer Name"
                error={!!this.state.newInboundProgram.customerNameErrorMessage}
                helperText={
                  this.state.newInboundProgram.customerNameErrorMessage
                }
                value={this.state.newInboundProgram.customerName}
                name={"customerName"}
                className={classes.textField}
                onChange={this.newOnChangeCustomerName}
                disabled={!isEagleSupervisor}
              />
            </Grid>
            <Grid item xs={6} sm={4} md={2}>
              <InboundPhone
                label="Toll Free Number"
                required
                value={this.state.newInboundProgram.tollFreeNumber}
                error={
                  !!this.state.newInboundProgram.tollFreeNumberErrorMessage
                }
                errorMessage={
                  this.state.newInboundProgram.tollFreeNumberErrorMessage
                }
                name={"tollFreeNumber"}
                onChange={this.newOnChange}
                disabled={!isEagleSupervisor}
              />
            </Grid>
            <Grid item xs={6} sm={4} md={2}>
              <MaterialInputable
                fullWidth
                label="Bill To"
                error={!!this.state.newInboundProgram.billToErrorMessage}
                errorMessage={this.state.newInboundProgram.billToErrorMessage}
                value={this.state.newInboundProgram.billTo}
                name={"billTo"}
                className={classes.textField}
                onChange={this.newOnChange}
                disabled={!isEagleSupervisor}
              />
            </Grid>
            {inboundProgramAccountTypes.filter(i => i.name === "Fleet")[0]
              .id === this.state.newInboundProgram.accountTypeId && (
                <Grid item xs={6} sm={4} md={2}>
                  <TextField
                    fullWidth
                    label="Ship To"
                    error={!!this.state.newInboundProgram.shipToErrorMessage}
                    helperText={this.state.newInboundProgram.shipToErrorMessage}
                    value={this.state.newInboundProgram.shipTo}
                    name={"shipTo"}
                    className={classes.textField}
                    onChange={this.newOnChange}
                    disabled={!isEagleSupervisor}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <Tooltip title="Search for Ship To Numbers">
                            <IconButton onClick={this.startShipToSearch}>
                              <SearchIcon />
                            </IconButton>
                          </Tooltip>
                        </InputAdornment>
                      )
                    }}
                  />
                </Grid>
              )
            }

            <Grid item xs={12}>
              <FormGroup row>
                <FormControlLabel
                  className={classes.checkbox}
                  control={
                    <Checkbox
                      checked={this.state.newInboundProgram.excludeAutoClose}
                      onChange={this.newOnChange}
                      name={"excludeAutoClose"}
                      color="primary"
                    />
                  }
                  label="Exclude from Auto Close"
                  disabled={!isEagleSupervisor}
                />
                <FormControlLabel
                  className={classes.checkbox}
                  control={
                    <Checkbox
                      checked={this.state.newInboundProgram.isEsd}
                      onChange={this.newOnChange}
                      name={"isEsd"}
                      color="primary"
                    />
                  }
                  label="Electronic Service Dispatch"
                  disabled={!isEagleSupervisor}
                />
                <FormControlLabel
                  className={classes.checkbox}
                  control={
                    <Checkbox
                      checked={this.state.newInboundProgram.isDisabled}
                      onChange={this.newOnChange}
                      name={"isDisabled"}
                      color="primary"
                    />
                  }
                  label="Disabled"
                  disabled={!isEagleSupervisor}
                />
                <FormControlLabel
                  className={classes.checkbox}
                  control={
                    <Checkbox
                      checked={this.state.newInboundProgram.assetValidationFlag}
                      onChange={this.newOnChange}
                      name={"assetValidationFlag"}
                      color="primary"
                    />
                  }
                  label="Asset Validation Flag"
                  disabled={!isEagleSupervisor}
                />
              </FormGroup>
            </Grid>

            <Panel
              title="Vehicle Types"
              control={
                <Button color="primary" onClick={() => { this.newNewOnChange() }} style={{ position: 'relative', top: '3px' }} disabled={!isEagleSupervisor}>
                  <AddIcon /> Add additional Vehicle Type
                </Button>
              }
            >
              {this.state.newInboundProgram.vehicleTypes && this.state.newInboundProgram.vehicleTypes.map((zz, index) => (
                <Grid item xs={12} key={index}>
                  <Grid container spacing={2}>
                    <Grid item xs={4}>
                      <MaterialSelectable
                        name={"vehicleTypes" + index}
                        label="Vehicle Asset"
                        fullWidth
                        onChange={this.newOnChange}
                        id={"vehicleTypes" + index}
                        value={this.state.newInboundProgram.vehicleTypes[index].vehicleTypesId}
                        options={vehicleTypes}
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <MaterialSelectable
                        name={"required" + index}
                        label="Required"
                        multiple
                        fullWidth
                        onChange={this.newOnChange}
                        id={"required" + index}
                        value={this.state.newInboundProgram.vehicleTypes[index].required ?
                          this.state.newInboundProgram.vehicleTypes[index].required.map(x => {
                            return x
                          }) : []}
                        options={vehicleTypes.map(type => ({ id: type.name, name: type.name }))}
                      />
                    </Grid>
                    <Grid item>
                      <Tooltip title="Remove">
                        <IconButton color="danger" onClick={() => { this.removeChange() }}><DeleteIcon /></IconButton>
                      </Tooltip>
                    </Grid>
                  </Grid>
                </Grid>
              ))}
            </Panel>

            <Grid item xs={12}>
              <MaterialSelectable
                name="assetTypes"
                label="Elements Required for Search"
                multiple
                fullWidth
                onChange={this.newOnChange}
                id="assetTypes"
                value={this.state.newInboundProgram.assetTypes ? this.state.newInboundProgram.assetTypes.map(x => {
                  if (x.assetValidation) {
                    return x.assetValidation.id
                  }
                  return x
                }) : []}
                input={<Input />}
                options={assetValidationTypes}
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <TextField
                variant="outlined"
                label="Asset Search Instructions"
                value={this.state.newInboundProgram.assetSuccessInstructions || ''}
                name={"assetSuccessInstructions"}
                className={classes.textField}
                multiline
                rows="4"
                fullWidth
                onChange={this.newOnChange}
                disabled={!isEagleSupervisor}
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <TextField
                variant="outlined"
                label="Asset Failure Instructions"
                value={this.state.newInboundProgram.assetFailureInstructions || ''}
                name={"assetFailureInstructions"}
                className={classes.textField}
                multiline
                rows="4"
                fullWidth
                onChange={this.newOnChange}
                disabled={!isEagleSupervisor}
              />
            </Grid>

            <Grid item xs={12}>
              {this.state.nameSearch && (
                <Paper className={classes.paper}>
                  <Table size="small">
                    <TableHead style={{ backgroundColor: 'rgba(0,0,0,.12)' }}>
                      <TableRow>
                        <TableCell className={classes.tableHead}>
                          Customer Name
                        </TableCell>
                        <TableCell className={classes.tableHead}>BillTo</TableCell>
                        <TableCell className={classes.tableHead}>
                          Account Type
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {this.state.potentialCustomers.map(row => {
                        return (
                          <TableRow
                            hover
                            key={row.id}
                            onClick={() => this.loadCustomer(row.customerName, row.billTo, row.accountTypeId)}
                            style={{ cursor: 'pointer' }}
                          >
                            <TableCell className={classes.tableCell}>
                              {row.customerName}
                            </TableCell>
                            <TableCell className={classes.tableCell}>
                              {row.billTo}
                            </TableCell>
                            <TableCell className={classes.tableCell}>
                              {row.accountTypeName}
                            </TableCell>
                          </TableRow>
                        );
                      })}
                    </TableBody>
                  </Table>
                </Paper>
              )}
              {this.state.shipToSearch && !this.state.nameSearch && (
                <Paper className={classes.paper}>
                  <Grid container spacing={1}>
                    <Grid item xs={4} md={3}>
                      <TextField
                        label="City"
                        value={this.state.shipToSearchCity}
                        name={"City"}
                        className={classes.textField}
                        fullWidth
                        onChange={this.shipToSearchChange}
                      />
                    </Grid>
                    <Grid item xs={4} md={3}>
                      <MaterialSelectable
                        label="State"
                        required
                        fullWidth
                        value={this.state.shipToSearchState}
                        name={"State"}
                        options={this.state.states}
                        onChange={this.shipToSearchChange}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <Table size="small">
                        <TableHead style={{ backgroundColor: 'rgba(0,0,0,.12)' }}>
                          <TableRow>
                            <TableCell className={classes.tableHead}>Address</TableCell>
                            <TableCell className={classes.tableHead}>City</TableCell>
                            <TableCell className={classes.tableHead}>State</TableCell>
                            <TableCell className={classes.tableHead}>Ship To</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {this.state.shipTos.map(row => {
                            return (
                              <TableRow
                                hover
                                key={row.id}
                                onClick={() => this.loadShipTo(row.accountNumber)}
                                style={{ cursor: 'pointer' }}
                              >
                                <TableCell className={classes.tableCell}>
                                  {row.address.address}
                                </TableCell>
                                <TableCell className={classes.tableCell}>
                                  {row.address.city}
                                </TableCell>
                                <TableCell className={classes.tableCell}>
                                  {row.address.state}
                                </TableCell>
                                <TableCell className={classes.tableCell}>
                                  {row.accountNumber}
                                </TableCell>
                              </TableRow>
                            );
                          })}
                        </TableBody>
                      </Table>
                    </Grid>
                  </Grid>
                </Paper>
              )}
            </Grid>
          </Grid>
        </DialogContent>

        <DialogActions>
          <Button onClick={() => { this.closeInbound() }} color="danger">Cancel</Button>
          <Button
            disabled={this.state.isSaving || !isEagleSupervisor}
            onClick={async () => {
              await this.startSave();
              await this.saveNewInbound();
            }}
            color="primary"
          >
            Save
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

NewDialog.propTypes = {
  classes: PropTypes.object,
  open: PropTypes.bool,
  newInboundProgram: PropTypes.object,
  inboundProgramAccountTypes: PropTypes.array,
  assetValidationTypes: PropTypes.array,
  isSaving: PropTypes.bool,
  closeMe: PropTypes.func,
  fetchNumbers: PropTypes.func,
  isEdit: PropTypes.bool,
  loadedProgram: PropTypes.object
};

export default withStyles(styles)(NewDialog);



// WEBPACK FOOTER //
// ./src/components/inbound/NewDialog.js